import fetchWebApi from 'api/fetchWebApi';

interface post2faCodePayload {
  verificationId: string;
  code: string;
  codeId: string;
  fingerprint: string;
}

// 2faOptionalComment: Remove changes related 2fa options when BE deployment is done on PROD [zaquiel]
export interface post2faCodeResponse {
  username?: string;
  token?: string;
  fromTemporaryPassword?: boolean;
}

const post2faCodeApiCall = async ({
  verificationId,
  code,
  codeId,
  fingerprint,
}: post2faCodePayload): Promise<post2faCodeResponse> => {
  const data = await fetchWebApi('/2fa/code', undefined, {
    method: 'post',
    headers: {
      'X-Verification-Id': verificationId,
      'x-code-id': codeId,
      'X-Device-Id': fingerprint,
    },
    body: JSON.stringify({ code }),
  });
  return data;
};

export default post2faCodeApiCall;
